import {Injectable, NgZone} from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {catchError, tap} from 'rxjs/operators';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Router} from '@angular/router';


@Injectable({
  providedIn: 'root'
})
export class ErrorInterceptor implements HttpInterceptor {


  constructor(private snackBar: MatSnackBar,
              private router: Router,
              private ngZone: NgZone) {

  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    return next.handle(req).pipe(
      tap(
        (event: HttpEvent<any>) => {
        },
        (err: any) => {
          if (err instanceof HttpErrorResponse) {
            const errMsg = (err.error !== null && (typeof(err.error) === 'object' && err.error.detail) ? err.error.detail : err.error ) || err.statusText;

            if (err.status === 403) {
              this.ngZone.run(() => {
                this.router.navigate(['/auth']);
              });
              return;
            } else if (err.status === 404 && req.headers.get("skip404")) {
              next.handle(req);
              return;
            }

            if (typeof(errMsg) === 'string') {
              this.snackBar.open(
                errMsg,
                null,
                {
                  panelClass: 'error-notification',
                  duration: 5000
                }
              );
            } else {
              console.log(errMsg);
            }
          }
        })
    );
  }

}
